import React from 'react';
import { cn } from '../../design-system/cn';
import { semanticColors, radii, motion } from '../../design-system/tokens';

/**
 * Pill — selectable/toggleable rounded chip. Consolidates the hand-rolled
 * filter/stake/tab pills (TicketMatchupPicker filters, StakeChipRow presets, …)
 * into one component. For sport-colored tabs see SportFilterBar (domain-specific).
 */
const TONES = {
  brand: {
    active: `${semanticColors.accent.borderEmphasis} ${semanticColors.accent.surfaceEmphasis} ${semanticColors.accent.textEmphasis}`,
    idle: `${semanticColors.border.DEFAULT} ${semanticColors.surface.inset} ${semanticColors.text.onDark} hover:border-gray-700`,
  },
  cyan: {
    active: 'border-cyan-500/50 bg-cyan-500/15 text-cyan-200',
    idle: `${semanticColors.border.strong} bg-black/30 ${semanticColors.text.secondary} hover:border-gray-600`,
  },
};

const SIZES = {
  sm: 'min-h-[36px] px-3 py-1.5 text-[10px]',
  md: 'px-4 py-2.5 text-sm',
  chip: 'px-3 py-2.5 text-sm',
};

const RADII = {
  pill: radii.pill,
  control: radii.controlMd,
};

export default function Pill({
  active = false,
  tone = 'brand',
  size = 'sm',
  radius = 'pill',
  disabled = false,
  className,
  children,
  ...props
}) {
  const toneSet = TONES[tone] || TONES.brand;
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      disabled={disabled}
      className={cn(
        'shrink-0 border font-black uppercase tracking-widest',
        RADII[radius] || radii.pill,
        motion.transition,
        SIZES[size] || SIZES.sm,
        active ? toneSet.active : toneSet.idle,
        'disabled:opacity-40 disabled:cursor-not-allowed',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
